// src/components/ContinuationIndicator.js
import React from 'react';
import './ContinuationIndicator.css';

const ContinuationIndicator = () => {
  return (
    <div className="continuation-indicator">
      <span className="continuation-text">Claude is continuing...</span>
      <div className="typing-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default ContinuationIndicator;